"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = exports.PopupProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_dom_1 = __importDefault(require("react-dom"));
const web_log_1 = require("@snapchat/web-log");
const POPUP_ID = "PopupProvider";
/**
 * Helper component to render any ReactNode above all app content
 */
function PopupProvider({ children }) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [children, (0, jsx_runtime_1.jsx)("div", { id: POPUP_ID })] }));
}
exports.PopupProvider = PopupProvider;
/**
 * Helper component to create React Portal.
 */
function Popup({ children }) {
    const element = document.getElementById(POPUP_ID);
    if (element) {
        return react_dom_1.default.createPortal(children, element);
    }
    web_log_1.log.error("Popup Provider not found");
    return null;
}
exports.Popup = Popup;
//# sourceMappingURL=Popup.js.map